export const locale = {
  lang: 'fr-CA',
  data: {
    CREATE_CLIENT: {
      TITLE: 'Nouveau client',
      TITLE_CONTACT: 'Infos contact client',
      TITLE_ADDRESS: 'Infos adresse client',
      COMM_LANGUAGE: 'Langue de communication',
    },
    CREATE_ENTERPRISE: {
      TITLE: 'Nouvelle entreprise',
      TITLE_CONTACT: 'Infos contact entreprise',
      TITLE_ADDRESS: 'Infos adresse entreprise',
    },
    CREATE_CLIENT_ENTERPRISE: {
      PANEL_TITLE: 'Nouveau client et nouvelle entreprise',
      COPY_ENTERPRISE_TO_CLIENT: "Copier l'adresse entreprise vers le client",
      COPY_CLIENT_TO_ENTERPRISE: "Copier l'adresse client vers l'entreprise",
    },
  },
};
